import { Contract, types } from "@jutro/contract";
export default Contract.specify({
  getAvailableLanguages: types.func,
  getAvailableLocales: types.func,
  getDefaultCountryCode: types.func,
  getDefaultTimeZone: types.func,
  getPreferredLanguage: types.func,
  getPreferredLocale: types.func
});